module.exports = __webpack_public_path__ + "img/9788958072232.23bd9009.jpg";